import GroupingSelector from './GroupingSelector'
import {ReportGroupingLevel} from './constants'
import messageResource from '../messageResource'
import {Feature, isEnabled} from '../features'
import _ from 'underscore'

export default function TTDetailsReportGroupingSelector() {
    this.constructor = TTDetailsReportGroupingSelector;
}

TTDetailsReportGroupingSelector.prototype = _.create(GroupingSelector.prototype);

TTDetailsReportGroupingSelector.prototype.init = function(selectorId, selectedValues, changesCallback)
{
    this.isBTYEnabled = isEnabled(Feature.BTY) || this._checkGroupingLevel(ReportGroupingLevel.BILLING_TYPE, selectedValues);
    this.isUGREnabled =  isEnabled(Feature.UGR) || this._checkGroupingLevel(ReportGroupingLevel.USER_GROUP, selectedValues);

    this.dateGroupingOrderList = [ ReportGroupingLevel.MONTH, ReportGroupingLevel.WEEK, ReportGroupingLevel.DATE ];

    this.maxLevels = 3;

    this.numberOfVisibleLevels = this.maxLevels; // init show all levels

    GroupingSelector.prototype.init.call(this, selectorId, this.maxLevels, selectedValues, changesCallback);

    this.setNumberOfVisibleLevels(this.calculateNumberOfVisibleLevels(selectedValues)); // hide rows if need

    this.errorMessagesMap[GroupingSelector.ERROR_GROUPING_DUPLICATE] = messageResource.getMessage("report.form.choose_grouping_opts");

    return this;
};
TTDetailsReportGroupingSelector.prototype._checkGroupingLevel = function (levelValue, selectedValues ) {
    for(let i = 0; i < selectedValues.length; i++){
        if (selectedValues[i] === levelValue) {
            return true;
        }
    }
    return false;
};

TTDetailsReportGroupingSelector.prototype.initListSelector = function(level, selectedValue, changesCallback)
{
    if (!selectedValue || selectedValue === ReportGroupingLevel.NONE) // set init values for selector if need
        selectedValue = level === 0 ? ReportGroupingLevel.CUSTOMER : level === 1 ? ReportGroupingLevel.PROJECT : ReportGroupingLevel.TASK;

    return GroupingSelector.prototype.initListSelector.call(this, level, selectedValue, changesCallback);
};

TTDetailsReportGroupingSelector.prototype.fillListSelector = function(listSelector)
{
    listSelector.addItems([{
                               text: messageResource.getEscapedMessage("common.Customers"),
                               value: ReportGroupingLevel.CUSTOMER
                           },
                           {
                              text: messageResource.getEscapedMessage("common.Projects"),
                              value: ReportGroupingLevel.PROJECT
                           },
                           {
                               text: messageResource.getMessage("report.form.smth_names",
                                                                [messageResource.getEscapedMessage("common.Project")]),
                               value: ReportGroupingLevel.PROJECT_NAME
                           },
                           {
                               text: messageResource.getEscapedMessage("common.Tasks"),
                               value: ReportGroupingLevel.TASK
                           },
                           {
                               text: messageResource.getMessage("report.form.smth_names",
                                                                [ messageResource.getEscapedMessage("common.Task")]),
                               value: ReportGroupingLevel.TASK_NAME
                           }
    ]);
    if( this.isBTYEnabled )
    {
        listSelector.addItems( [{
                                    text: messageResource.getMessage( "report.form.billing_types" ),
                                    value: ReportGroupingLevel.BILLING_TYPE
                                }] );
    }
    listSelector.addSeparator();
    listSelector.addItems( [{
                                text: messageResource.getMessage( "report.form.users" ),
                                value: ReportGroupingLevel.USER
                            }] );
    if( this.isUGREnabled )
    {
        listSelector.addItems( [{
                                    text: messageResource.getEscapedMessage("common.User_Groups"),
                                    value: ReportGroupingLevel.USER_GROUP
                                }] );
    }
    listSelector.addSeparator();
    listSelector.addItems([{
                               text: messageResource.getMessage("reports.comments_report.form.dates"),
                               value: ReportGroupingLevel.DATE
                           },
                           {
                               text: messageResource.getMessage("reports.comments_report.form.weeks"),
                               value: ReportGroupingLevel.WEEK
                           },
                           {
                               text: messageResource.getMessage("reports.comments_report.form.months"),
                               value: ReportGroupingLevel.MONTH
                           }]);
};

TTDetailsReportGroupingSelector.prototype.validate = function()
{
    if (!GroupingSelector.prototype.validate.call(this))
        return false;

    if ( !this.verifyDateGroupingOrder() ) {
        this.error = GroupingSelector.ERROR_INCORRECT_GROUPING_ORDER;
        return false;
    }

    return true;
};

TTDetailsReportGroupingSelector.prototype.setValues = function( values ) {
    GroupingSelector.prototype.setValues.call(this, values);
    this.setNumberOfVisibleLevels(this.calculateNumberOfVisibleLevels(values));
};

TTDetailsReportGroupingSelector.prototype.calculateNumberOfVisibleLevels = function( selection ) {
    let nVisibleLevels = 0;
    for( let i = 0; i < selection.length; i++) {
        if (selection[i] !== ReportGroupingLevel.NONE) {
            nVisibleLevels++;
        }
    }
    return nVisibleLevels;
};

TTDetailsReportGroupingSelector.prototype.getValues = function() {
    const selection = [];

    for (let i = 0; i < this.getNumberOfMaxLevels(); i++){
        if (i < this.getNumberOfVisibleLevels()) {
            selection.push(this.getListSelectorValue(i));
        } else {
            selection.push(ReportGroupingLevel.NONE);
        }
    }
    return selection;
};

TTDetailsReportGroupingSelector.prototype.getNumberOfVisibleLevels = function()
{
    return this.numberOfVisibleLevels;
};

TTDetailsReportGroupingSelector.prototype.getNumberOfMaxLevels = function() {
    return this.maxLevels;
};

TTDetailsReportGroupingSelector.prototype.setNumberOfVisibleLevels = function(numberOfLevels)
{
    const currentNumberOfLevels = this.getNumberOfVisibleLevels();

    const rowsToHide = currentNumberOfLevels - numberOfLevels;
    const rowsToShow = numberOfLevels - currentNumberOfLevels;

    let i;
    for (i=0; i < rowsToHide; i++)
    {
        this.hideRow(currentNumberOfLevels - i - 1);
    }

    for (i=0; i < rowsToShow; i++)
    {
        this.showRow(numberOfLevels - i - 1);
    }

    this.numberOfVisibleLevels = numberOfLevels;
};

TTDetailsReportGroupingSelector.prototype.verifyDateGroupingOrder = function()
{
    if ( this.getNumberOfVisibleLevels() <= 1 )
        return true;

    const firstLevel = this.dateGroupingOrderList.indexOf( this.getListSelectorValue(0) );
    const secondLevel = this.dateGroupingOrderList.indexOf( this.getListSelectorValue(1) );

    if ( secondLevel >= 0 && secondLevel < firstLevel )
        return false;

    if ( this.getNumberOfVisibleLevels() === 2 )
        return true;

    const thirdLevel = this.dateGroupingOrderList.indexOf( this.getListSelectorValue(2) );

    if ( thirdLevel < 0 )
        return true;

    return !(thirdLevel < firstLevel || thirdLevel < secondLevel);
};

TTDetailsReportGroupingSelector.prototype.updateTree = function()
{
    if (this.getNumberOfVisibleLevels() > 2)
        this.setRowClassName(2, "tree-row-SA");
    if (this.getNumberOfVisibleLevels() > 1)
        this.setRowClassName(1, "tree-row-A");
};



// WEBPACK FOOTER //
// ./web/js/reports/TTDetailsReportGroupingSelector.js